export default [
  { name: 'freight', label: 'Freight' },
  { name: 'freight_free', label: 'Freight (free)' },
  { name: 'small_parcel', label: 'Small Parcel' },
  { name: 'small_parcel_free', label: 'Small Parcel (free)' },
  { name: 'ltl_direct', label: 'LTL Direct' },
  { name: 'ltl_direct_free', label: 'LTL Direct (free)' },
  { name: 'e_deliver', label: 'Email' }
]